import { render, staticRenderFns } from "./SubstanceList.vue?vue&type=template&id=42039718&"
import script from "./SubstanceList.vue?vue&type=script&lang=js&"
export * from "./SubstanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports